import * as React from 'react';
import { isArray } from 'util';
import * as _ from 'lodash';

interface ISubNavMenuItemProps {
    name: string;
    location: string;
    path: string | Array<string>;
    navigate: (path: string) => void;
    section: string;
    onClick?: () => void;
}

const SubNavMenuItem: React.StatelessComponent<ISubNavMenuItemProps> = (props) => {
    let propPaths: Array<string> = null;
    if (isArray(props.path)) {
        propPaths = props.path;
    } else {
        propPaths = [props.path];
    }

    const hasWildCard = (x: string[]) => x.some((y) => y.includes('*'));
    const numToWildCard = (x: string) => x.replace(new RegExp('\\d+', 'g'), '*');
    const regexMatched = (propLocation: string, propPathArray: string[]) => {
        const regLocation: string = numToWildCard(propLocation);
        const propPathsCopy = _.cloneDeep(propPathArray);
        const regPaths = propPathsCopy.map((v: string) => numToWildCard(v));
        return regPaths.some((x: string) => (regLocation === x ? true : false));
    };

    let currentPathMatch = false;
    switch (props.section) {
        case 'main':
            if (props.location === '/' && propPaths[0] === '/') {
                currentPathMatch = true;
            } else {
                currentPathMatch = propPaths[0] !== '/' && props.location.startsWith(propPaths[0]);
            }
            break;
        case 'admin':
            currentPathMatch = props.location === propPaths[0];
            break;
        case 'project':
            if (hasWildCard(propPaths)) {
                currentPathMatch = regexMatched(props.location, propPaths);
            } else {
                currentPathMatch = props.location === props.path;
            }
            break;
        default:
            break;
    }

    const menuClass = currentPathMatch ? 'active' : '';
    const clickAction = () => {
        if (typeof props.onClick === 'function') {
            props.onClick();
        }
        props.navigate(propPaths[0]);
    };
    // TODO: refine logic, only disallow when on exact path..
    // const clickAction = !currentPathMatch ? () => props.navigate(props.path) : undefined;

    return (
        <div className={'sub-nav-menu-item ' + menuClass} onClick={clickAction}>
            {props.name}
        </div>
    );
};

export default SubNavMenuItem;



// WEBPACK FOOTER //
// ./src/components/layout/SubNavMenuItem.tsx